/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

xplenty.directive('timePicker', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/time-picker.html'),

      replace: true,

      scope: {
        time: '=ngModel',
      },

      link(scope, element, attrs) {
        const $input = element.find('input');
        const format = 'HH:mm';

        element
          .datetimepicker({
            format,
            date: moment(scope.time),
            icons: {
              time: 'fa fa-clock-o',
              date: 'fa fa-calendar',
              up: 'fa fa-arrow-up',
              down: 'fa fa-arrow-down',
              next: 'fa fa-arrow-right',
              previous: 'fa fa-arrow-left',
            },
          })
          .on('dp.change', function (e) {
            if (e.date) {
              scope.time.hours = e.date.hours();
              scope.time.minutes = e.date.minutes();
              scope.$parent.$apply();
            } else {
              $(e.target).data('DateTimePicker').date(moment(scope.time).format(format));
            }
          });
      },
    };
  },
]);
